import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import connect from 'components/lib/connect';
import Paginate from 'components/common/paginate';
import StackContainer from 'components/common/containers/stack_container';
import { Table, TBody, TD, TH, THead, TR } from 'components/common/table';
import AgentPerformanceTableRow from './agent_performance_table_row';

export const PAGE_ROW_COUNT = 25;

export class AgentPerformanceTable extends React.Component {
  constructor(props) {
    super(props);
    _.bindAll(this, ['handleChangePage', 'renderAgentPerformanceTableRow']);

    let paginationStartIndex = this.props.paginationStartIndex || 0;
    this.state = {
      agentsForPage: this.getAgentsForPage(this.props.allAgents, paginationStartIndex),
      allAgents: this.props.allAgents,
      paginationStartIndex,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.allAgents !== this.props.allAgents) {
      let paginationStartIndex = this.state.paginationStartIndex;
      if (nextProps.allAgents.length < PAGE_ROW_COUNT || nextProps.textFilter !== this.props.textFilter) {
        paginationStartIndex = 0;
      }
      this.setState({
        agentsForPage: this.getAgentsForPage(nextProps.allAgents, paginationStartIndex),
        allAgents: nextProps.allAgents,
        paginationStartIndex,
      });
    }
  }

  getAgentsForPage(allAgents, paginationStartIndex) {
    return allAgents.slice(paginationStartIndex, paginationStartIndex + PAGE_ROW_COUNT);
  }

  render() {
    return (
      <React.Fragment>
        <StackContainer inset="none" stack="small">
          <Agents data-aid="agent-performance-report-table" inset="small" stickyHeader zebra>
            <THead>
              <TR>
                <NameCell data-aid="nameHeader">
                  <FirstCell>Name</FirstCell>
                </NameCell>
                <MetricHeaderCell data-aid="metricHeader">Customers Helped per Hour</MetricHeaderCell>
                <MetricHeaderCell data-aid="metricHeader">% Time Helping Customers</MetricHeaderCell>
                <MetricHeaderCell data-aid="metricHeader">Avg. Active Conversation Handle Time</MetricHeaderCell>
                <MetricHeaderCell data-aid="metricHeader">% Utilized</MetricHeaderCell>
                <MetricHeaderCell data-aid="metricHeader">
                  <LastCell>Responses per Hour</LastCell>
                </MetricHeaderCell>
              </TR>
            </THead>
            <TBody>{this.renderAgents()}</TBody>
          </Agents>
          {this.state.allAgents.length > PAGE_ROW_COUNT && (
            <Paginate
              from={this.state.paginationStartIndex}
              onChange={this.handleChangePage}
              size={PAGE_ROW_COUNT}
              total={this.state.allAgents.length}
            />
          )}
        </StackContainer>
      </React.Fragment>
    );
  }

  renderAgentPerformanceTableRow(agent) {
    return (
      <AgentPerformanceTableRow
        agent={agent}
        agentPerformanceReportForAgent={this.props.agentPerformanceReport.getReportForAgent(agent.id)}
        key={agent.id}
      />
    );
  }

  renderAgents() {
    if (this.state.agentsForPage.length === 0) {
      return (
        <TR>
          <NoAgentsCell colSpan="6" data-aid="noAgentsCell">
            No agents to display
          </NoAgentsCell>
        </TR>
      );
    }
    return _.map(this.state.agentsForPage, this.renderAgentPerformanceTableRow);
  }

  handleChangePage(paginationStartIndex) {
    let agentsForPage = this.state.allAgents.slice(paginationStartIndex, paginationStartIndex + PAGE_ROW_COUNT);
    this.setState({ agentsForPage, paginationStartIndex });
  }
}

AgentPerformanceTable.propTypes = {
  agentPerformanceReport: PropTypes.object,
  allAgents: PropTypes.arrayOf(Object),
  paginationStartIndex: PropTypes.number,
  textFilter: PropTypes.string,
};

const AgentPerformanceTableContainer = connect(mapStateToProps)(AgentPerformanceTable);

function mapStateToProps({ getProvider }) {
  const report = getProvider('report').get();

  const agentsProvider = getProvider('agents');
  const currentLocation = getProvider('currentLocation').get();
  const agentPerformanceReport = report.getPerformanceReport();
  const allAgents = getAllAgentsAlphabetized();

  function getAllAgentsAlphabetized() {
    const agents = _.map(agentPerformanceReport.getAllAgentIds(), agentId => {
      return { name: getAgentName(agentId), id: agentId };
    });

    return _.sortBy(agents, ['name']);
  }

  function getAgentName(agentId) {
    let agent = agentsProvider.findBy({ id: agentId });
    return agent ? agent.getDisplayName() : '';
  }

  return {
    agentPerformanceReport,
    allAgents,
    paginationStartIndex: _.get(currentLocation, 'paginationStartIndex'),
  };
}

export const Agents = styled(Table).attrs({ inset: 'small' })`
  border-left: none;
  border-right: none;
  margin-bottom: ${p => p.theme.spacing.stackLarge};
`;

export const FirstCell = styled.div`
  padding-left: 50px;
`;

export const LastCell = styled.div`
  padding-right: 50px;
`;

const NoAgentsCell = styled(TD)`
  padding-left: ${p => p.theme.spacing.insetLarge};
`;

const NameCell = styled(TH)`
  word-break: break-word;
`;

const MetricHeaderCell = styled(TH)`
  word-break: break-word;
  text-align: right;
  align-items: right;
`;

export default AgentPerformanceTableContainer;
